import { React, useState } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { LocationAutocomplete } from "..";
import { Dialog, DialogTitle, Snackbar, Alert } from "@mui/material";

function LocationCreate(props) {
  const { updateTable, setUpdateTable } = props;
  const [openCreateDialog, setOpenCreateDialog] = useState(false);

  const [locationName, setLocationName] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleLocationCreate = (event) => {
    event.preventDefault();
    const body = new FormData();
    body.append("locationName", locationName);
    axios.post("/faculty/createLocation", body).then((res) => {
      const data = res.data;
      if (data.success) {
        resetHooks();
        setOpenCreateDialog(false);
        setUpdateTable(!updateTable);
      } else {
        setSnackbarMessage(data.message);
        setSnackbarOpen(true);
      }
    });
  };

  const resetHooks = () => {
    setLocationName("");
  };

  function showCreateDialog() {
    return (
      <Dialog open={openCreateDialog} maxWidth={false}>
        <DialogTitle className="LocationCreate-title mx-auto text-2xl font-bold font-brand-primary mt-4">
          Create Location
        </DialogTitle>
        <div className="LocationCreate-modalContainer flex flex-col w-fit mb-4">
          <div className="LocationCreate-locationContainer flex flex-col w-96 mx-auto mb-2">
            <div className="LocationCreate-location text-lg font-brand-primary">
              Location *
            </div>
            <LocationAutocomplete
              idAndClassName="JobSearch-LocationSearch"
              locationValue={locationName}
              setLocationValue={setLocationName}
              key={100}
            />
          </div>
          <div className="LocationCreate-buttonContainer flex justify-between px-12 mt-4">
            <button
              type="button"
              className="primary-button bg-brand-quaternary mb-2 h-11 pt-3 mr-4"
              onClick={handleLocationCreate}
            >
              Create Location
            </button>

            <button
              type="button"
              className="primary-button bg-brand-primary mb-2 h-11 pt-3"
              onClick={() => setOpenCreateDialog(false)}
            >
              Cancel
            </button>
          </div>
        </div>
        <Snackbar
          open={snackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={() => {
            setSnackbarOpen(false);
            setSnackbarMessage("");
          }
          }
        >
          <Alert
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }
            }
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Dialog>
    );
  }

  return (
    <div className="LocationCreate-container">
      {showCreateDialog()}
      <button
        type="button"
        className="LocationCreate-button search-button px-4 h-11 mb-4 mr-4 text-center py-2"
        onClick={() => setOpenCreateDialog(true)}
      >
        Create Location
      </button>
    </div>
  );
}

LocationCreate.propTypes = {
  updateTable: PropTypes.bool,
  setUpdateTable: PropTypes.func,
};

LocationCreate.defaultProps = {
  updateTable: false,
  setUpdateTable: () => { },
};

export default LocationCreate;
